import { CustomerEngagementPlanning } from 'generated/maya.types';

export type CepViewPropsType = {
  cep?: CustomerEngagementPlanning;
};

export enum CepViewStepsIndex {
  configurationStep = 0,
  targetListStep = 1,
  tacticsStep = 2,
  costEstimationStep = 3,
}
